import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { LexTranslateService } from '@app/core/services/lex-translate.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
    selector: 'seb-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.css']
})

export class ConfirmationComponent implements OnInit {

    bbClose: Boolean = true;
    labelBtnConfirmation: String;
    @Output() evConfirmation: EventEmitter<any> = new EventEmitter<any>();
    @Input() labelTitleModal: String;
    @ViewChild('confirmationModal') modalExport: ModalComponent;

    constructor(
        public lextranslate: LexTranslateService
    ) { }

    ngOnInit(): void { 
        this.labelBtnConfirmation = this.lextranslate.i18n['faa7ed57-0878-4b2c-94d5-4f4bdf8e7e16']
    }


    openModalConfirmation() {
        this.modalExport.openBackDropCustomClass(this.modalExport.content);
    }

    onConfirm(confim:Boolean){
        this.evConfirmation.emit(confim);
    }
}
